// Backend API URL
// Development için: http://localhost:9000
// Production için: boş string (Nginx proxy kullanır)

const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export const API_URL = isDevelopment ? "http://localhost:9000" : "";